import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface FormIconProps {
  className?: string;
  icon: IconDefinition;
}

export const FormIcon = ({ className, icon }: FormIconProps) => {
  const iconClassName = typeof className === 'string' ? className : '';
  return (
    <div className="flex justify-center items-center p-2 bg-surface-200 dark:bg-slate-700 rounded-s-[var(--form-radius)]">
      <FontAwesomeIcon fixedWidth icon={icon} className={iconClassName} />
    </div>
  );
};